import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app.component';
import { createCustomElement } from '@angular/elements';
import { IncidenceAddMessageComponent } from './app/components/shared/incidence-add-message/incidence-add-message.component';
import { IncidenceInfoComponent } from './app/components/shared/incidence-info/incidence-info.component';
import { IncidenceMessageListComponent } from './app/components/shared/incidence-message-list/incidence-message-list.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import * as Highcharts from 'highcharts';
import { environment } from './environments/environment';
import DataTable from 'datatables.net';

import 'datatables.net-bs5';
DataTable.ext.classes.search.input = 'form-control';
DataTable.ext.classes.length.select = 'form-select';

if (environment.production) {
  enableProdMode();
  window.console.log = function (): void { };
  window.console.table = function (): void { };
  window.console.debug = function (): void { };
  window.console.warn = function (): void { };
  window.console.info = function (): void { };
}

bootstrapApplication(App, {
  ...appConfig,
  providers: [
    ...(appConfig.providers ?? []),
    provideAnimationsAsync(),
  ],
})
  .then(appRef => {
    // Registramos el web component
    // Nombre de la etiqueta que podrán usar tus HTML dinámicos
    if (!customElements.get('incidence-add-message')) {
      customElements.define(
        'incidence-add-message',
        createCustomElement(IncidenceAddMessageComponent, { injector: appRef.injector })
      );
    }

    if (!customElements.get('incidence-info')) {
      customElements.define(
        'incidence-info',
        createCustomElement(IncidenceInfoComponent, { injector: appRef.injector })
      );
    }

    if (!customElements.get('incidence-message-list')) {
      customElements.define(
        'incidence-message-list',
        createCustomElement(IncidenceMessageListComponent, { injector: appRef.injector })
      );
    }
  })
  .catch((err) => console.error(err));


Highcharts.setOptions({
  lang: {
    decimalPoint: ',',
    thousandsSep: '.',
    months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
    weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
    shortWeekdays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
    loading: 'Cargando...',
    noData: 'Sin datos para mostrar',
    resetZoom: 'Restablecer zoom',
    resetZoomTitle: 'Restablecer zoom nivel 1:1'
  }
} as any);
